import { useEffect, useState } from "react";
import { postData } from "../axios/axiosHelper";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { consumeSessionExpiryNotice } from "../auth/sessionExpiry";
import {
  hasAdminToken,
  saveAdminToken
} from "../auth/adminSession";

const LoginHook = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const sessionExpiryNotice = consumeSessionExpiryNotice();
    if (sessionExpiryNotice) {
      toast.error(sessionExpiryNotice);
    }

    if (hasAdminToken()) {
      navigate("/");
    }
  }, [navigate]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const handleInputChange = (event) => {
    const { checked, name, type, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    await postData("/admin/auth/login", formData)
      .then((response) => {
        if (response?.data?.verify) {
          toast.success(response?.data?.message);
        } else {
          saveAdminToken(response?.data?.token, {
            rememberMe: formData.rememberMe,
          });
          toast.success(response?.data?.message);
          navigate("/");
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };
  return {
    showPassword,
    setShowPassword,
    togglePasswordVisibility,
    formData,
    setFormData,
    loading,
    handleLogin,
    handleInputChange,
  };
};

export default LoginHook;
